import Paper from '@mui/material/Paper';
import './ContractViewer.scss';

const ContractViewer = props => (
  <Paper className='ContractViewer'>
    <div className='ContractViewer__content' dangerouslySetInnerHTML={{__html: props.html}} />
  </Paper>
);

export default ContractViewer;
